import { MutableRefObject } from 'react';

import { Field, Form, FormTheme } from '@kanda-libs/ks-component-ts';
import {
  Button,
  Loader,
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';

import DeclineOption from './DeclineOption';
import {
  DECLINE_QUOTE_MODAL_ID,
  OPTIONS,
  REQUEST_VALIDATION,
} from './constants';
import useDeclineQuoteModalForm from './useDeclineQuoteModal';

const DeclineQuoteModal: React.FunctionComponent = function () {
  const { form, onSubmit, isSubmitting, option, onOptionClick, error } =
    useDeclineQuoteModalForm();
  return (
    <ModalContainer id={DECLINE_QUOTE_MODAL_ID} opacity={40}>
      {({ ref, handleClose }) => (
        <ModalLayoutCenter
          id={DECLINE_QUOTE_MODAL_ID}
          ref={ref as MutableRefObject<HTMLDivElement>}
          onClose={isSubmitting ? undefined : handleClose}
          className="w-11/12 max-w-128"
        >
          <Form form={form} id="request-quote-changes" onSubmit={onSubmit}>
            <FormTheme variant="streamline">
              <div className="flex flex-col gap-y-4">
                <div className="w-full pr-8">
                  <h2 className="text-16-24-em md:text-20-24-em">
                    Before you go, please let us know why you are declining your
                    quote
                  </h2>
                </div>
                <div className="flex flex-col gap-y-3 mt-2">
                  {OPTIONS.map((currentOption) => (
                    <DeclineOption
                      {...currentOption}
                      active={option === currentOption.id}
                      onClick={() => onOptionClick(currentOption)}
                      key={currentOption.id}
                    />
                  ))}
                </div>
                <div className="hidden">
                  <Field.Validator validation={REQUEST_VALIDATION}>
                    <Field.Input name="reason" />
                  </Field.Validator>
                </div>
                {error && (
                  <p className="text-12-18 text-red-200 -mt-2">{error}</p>
                )}
                <div className="flex flex-col-reverse sm:flex-row gap-x-3 gap-y-3 mt-1">
                  <Button.Text
                    id="decline-quote-cancel"
                    variant="outline"
                    label={
                      <p className="text-14-22-em text-neutral-800 -mx-6">
                        Cancel
                      </p>
                    }
                    className="hover:bg-neutral-100 w-full"
                    onClick={handleClose}
                    disabled={isSubmitting}
                  />
                  <Button.Text
                    id="decline-quote-submit"
                    submit
                    label="Submit"
                    className="w-full"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </FormTheme>
          </Form>
          <Loader isLoading={isSubmitting} />
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default DeclineQuoteModal;
